import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Loading from './Loading';
import Share from './Share';
import { addNote, updateNote, deleteNote } from '../../../utils/Api';
import { truncString } from '../../../utils/helper';
import { Editor } from 'react-draft-wysiwyg';
import {
  EditorState as EditorStateText,
  ContentState as ContentStateText,
  convertToRaw,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

class Item extends React.Component {
  constructor(props) {
    super(props);

    const { text } = props;
    this.state = {
      isLoaded: true,
      modal: false,
      initialText: text,
      text,
      editorStateStart: text,
    };

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.onEditorStateChangeText = this.onEditorStateChangeText.bind(this);
  }

  toggle() {
    const { modal } = this.state;
    const { text } = this.props;
    this.setState({ modal: !modal, text });
  }

  handleChange({ target }) {
    this.setState({ text: target.value });
  }

  handleAdd() {
    const { text } = this.state;
    const { id, onDelete } = this.props;
    this.setState({ isLoaded: false });
    addNote(id, text).then(() => {
      this.setState({ isLoaded: true, modal: false, text: '' });
      onDelete();
    });
  }

  handleUpdate() {
    this.setState({ isLoaded: false });
    const { text } = this.state;
    const { id, onDelete } = this.props;
    updateNote(id, text).then(() => {
      this.setState({ isLoaded: true, modal: false, initialText: text });
      onDelete();
    });
  }

  handleDelete(e) {
    e.stopPropagation();
    const { intl, id, onDelete } = this.props;
    if (window.confirm(intl.formatMessage({ id: 'notes_youSure' }))) {
      this.setState({ isLoaded: false });
      deleteNote(id).then(() => {
        this.setState({ modal: false });
        onDelete();
      });
    }
  }

  onEditorStateChangeText(editorStateText) {
    this.setState({ editorStateText });

    // remove empty paragraphs, newline is enough .replace(/<p><br><\/p>/g, '');
    const text = draftToHtml(convertToRaw(editorStateText.getCurrentContent()));
    this.state.text = this.state.text || '';
    if (this.state.start_text !== text) {
      this.setState({ text });
    }
  }

  render() {
    const { isLoaded, modal, initialText, text } = this.state;
    const { intl, permissions, actionType, disabled, locale, id } = this.props;

    if (!this.state.editorStateText) {
      const { contentBlocks, entityMap } = htmlToDraft(text);
      const contentStateText = ContentStateText.createFromBlockArray(
        contentBlocks,
        entityMap,
      );
      this.state.editorStateStart =
        EditorStateText.createWithContent(contentStateText);
    }

    return (
      <React.Fragment>
        <button
          type="button"
          className="tile_link completed"
          onClick={this.toggle}
          disabled={disabled}
        >
          {actionType === 'add' ? (
            // ? intl.formatMessage({ id: "notes_addNote" })
            <span>
              {/* <i className="fa fa-sticky-note-o fa-5x" /> */}
              <i className="icon_c_xl icon_c_bg icon_note_add" />
              {/* <i className="fa fa-plus fa-3x" style={{ position: "relative", top: "50%" }} /> */}
            </span>
          ) : (
            [
              <p>{truncString(initialText, 480)}</p>,
              <div
                style={{ position: 'absolute', bottom: '10px', left: '10px' }}
                onClick={this.handleDelete}
                disabled={!permissions.includes('LESSON_MY_PICTURES_DELETE')}
              >
                {/* <i className="fa fa-trash fa-2x" /> */}
                <i className="icon_c icon_c_bg icon_delete" />
              </div>,
              <div
                style={{ position: 'absolute', bottom: '10px', right: '10px' }}
              >
                <Share key={locale} message={{ note_id: id, shared: true }} />
              </div>,
            ]
          )}
          <Modal isOpen={modal} toggle={this.toggle} className="modal-lg">
            {!isLoaded && <Loading />}
            <ModalHeader toggle={this.toggle}>
              <FormattedMessage id="notes_editNote" />
            </ModalHeader>
            <ModalBody>
              <Editor
                editorState={this.state.editorStateText}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={this.onEditorStateChangeText}
              />
            </ModalBody>
            <ModalFooter>
              {actionType === 'update' && (
                <Button
                  color="danger"
                  style={{ position: 'absolute', left: 17 }} // TODO: get rid of position:absolute
                  onClick={this.handleDelete}
                  disabled={!permissions.includes('LESSON_MY_NOTES_DELETE')}
                >
                  <FormattedMessage id="overall_input_delete" />
                </Button>
              )}
              {actionType === 'add' && (
                <Button
                  color="primary"
                  onClick={this.handleAdd}
                  disabled={!permissions.includes('LESSON_MY_NOTES_ADD')}
                >
                  <FormattedMessage id="overall_input_add" />
                </Button>
              )}
              {actionType === 'update' && (
                <Button
                  color="primary"
                  onClick={this.handleUpdate}
                  disabled={!permissions.includes('LESSON_MY_NOTES_UPDATE')}
                >
                  <FormattedMessage id="overall_input_save" />
                </Button>
              )}
              <Button color="secondary" onClick={this.toggle}>
                <FormattedMessage id="overall_input_cancel" />
              </Button>
            </ModalFooter>
          </Modal>
        </button>
      </React.Fragment>
    );
  }
}

Item.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  actionType: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
};

export default injectIntl(Item);



// WEBPACK FOOTER //
// ./src/views/_Lessons/Notes/Item.js